import { render, staticRenderFns } from "./connect_box.vue?vue&type=template&id=b1b956b6&scoped=true"
import script from "./connect_box.vue?vue&type=script&lang=js"
export * from "./connect_box.vue?vue&type=script&lang=js"
import style0 from "./connect_box.vue?vue&type=style&index=0&id=b1b956b6&prod&scoped=true&lang=css"
import style1 from "./connect_box.vue?vue&type=style&index=1&id=b1b956b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b956b6",
  null
  
)

export default component.exports